import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const html = new BlockType({
  name: 'html',
  title: 'HTML',
  compatibility: ['page'],
  component: () => import('./HtmlBlock.vue'),
  builder: () => BlockBuilder.create('html').property('html', ''),
});
